import React from 'react';
import {BoxArrowInUpRight} from 'react-bootstrap-icons';

function getStandardLink(text, url, blank){
  return (
    <a href={url} target={blank ? "_blank" : "_self"} style={{"text-decoration":"none", "color":" #192056"}}>{text} <BoxArrowInUpRight color="grey"/></a>
  )
}

export {getStandardLink};